export default {
    inputTitle: 'Chiffre :x sur :y du code à usage unique',
};
